import { paths } from 'src/routes/paths';

// Puntini delle novità sulle voci del menu, scelti dall'utente il 2026-10-16.
export const HIGHLIGHTS = [
  {
    id: 'invii-firme',
    path: paths.dashboard.documentSignatures,
    title: 'Invii e firme',
    text: 'Prepara un documento e invialo a uno o più dipendenti da firmare. Nel registro segui come procede.',
  },
  {
    id: 'trasparenza-retributiva',
    path: paths.dashboard.payTransparency,
    title: 'Trasparenza retributiva',
    text: 'Confronta le retribuzioni di uomini e donne e scopri il divario retributivo di genere.',
  },
];
